import { useEffect, useState } from 'react';
import { JAI_COLORS, JAI_FONTS } from './JaiBrand';
import { getConsentDecision, grantConsent, denyConsent } from '../analytics';

/**
 * First-visit cookie banner. Analytics (PostHog — autocapture, session
 * replay) does not start until the visitor accepts here; see the
 * consent gating in analytics.js. Declining is remembered too, so we never
 * ask twice.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsentDecision() === null);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    grantConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    denyConsent();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        // Centers against the content pane, not the raw viewport — offsets
        // past the sidebar when one is open (see AppShell's --sidebar-offset).
        left: 'calc(var(--sidebar-offset, 0px) + 16px)',
        right: 16,
        bottom: 16,
        zIndex: 2000,
        maxWidth: 640,
        margin: '0 auto',
        transition: 'left 220ms cubic-bezier(0.4,0,0.2,1)',
        background: JAI_COLORS.navy,
        color: JAI_COLORS.white,
        borderRadius: 14,
        boxShadow: '0 12px 32px rgba(4,18,46,0.35)',
        padding: '18px 20px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 16,
        fontFamily: JAI_FONTS.tight,
      }}
    >
      <p style={{ margin: 0, flex: '1 1 320px', fontSize: 14, lineHeight: 1.5, color: 'rgba(255,255,255,0.85)' }}>
        JAI uses cookies to keep you signed in and to understand how the app is used.{' '}
        <a href="/privacy#cookies" style={{ color: JAI_COLORS.blueBright, textDecoration: 'underline' }}>
          Learn more
        </a>
        .
      </p>
      <div style={{ display: 'flex', gap: 10, flex: '0 0 auto' }}>
        <button
          type="button"
          onClick={handleDecline}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.25)',
            background: 'transparent',
            color: JAI_COLORS.white,
            fontFamily: JAI_FONTS.tight,
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Decline
        </button>
        <button
          type="button"
          onClick={handleAccept}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            border: 'none',
            background: JAI_COLORS.blueBright,
            color: JAI_COLORS.white,
            fontFamily: JAI_FONTS.tight,
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
